import Component from './Refresher.vue';

export default {
  install(Vue) {
    Vue.component('BkfRefresher', Component);
  },
};
